<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3W5nE4/tc-custom/9781449400187.jpg?1705766127459" alt="This image is the cover for the book Cider Beans, Wild Greens, and Dandelion Jelly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cider Beans, Wild Greens, and Dandelion Jelly
      </h1>
      <p class="bookDescription body article font2">
        <b>Down-home and delicious recipes from southern Appalachia, plus photos and tidbits on the region’s history and culture.</b><br/><br/>There are many cookbooks about Southern cooking, but precious few celebrate the southern Appalachian food that has sustained mountain folk past and present. Thankfully, we now have Joan E. Aller’s <i>Cider Beans, Wild Greens, and Dandelion Jelly</i>.<br/><br/>Featuring more than 150 recipes for down-home, soul-satisfying dishes, this is more than just a cookbook. Complete with passages on the history, places, and people of southern Appalachia, along with lush full-color photography of the food and scenery of the southern Appalachian Mountains, <i>Cider Beans, Wild Greens, and Dandelion Jelly</i> serves as both a cookbook and a guided tour of the local lore, traditions, and culture of this uniquely American region. <br/><br/>“For all foodies and lovers of hearty food that feeds both body and soul, Joan Aller unearths a mother lode of southern Appalachian sustenance.” —<i>Appalachian News</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joan E. Aller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19f5dd82